import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [toggleicon, setToggleicon] = useState(true);
  const [crossicon, setCrossicon] = useState(false);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const handleToggle = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };
  const closeMenu = () => {
    setIsNavbarOpen(false);
  };
  return (
    <>
      <nav class='navbar navbar-expand-lg navbar-light header-bg'>
        <Link class='navbar-brand' to={'/'}>
          <img src='/images/codingveda.png' width='250' alt='LOGO' />
        </Link>
        <button
          class='navbar-toggler'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#navbarNav'
          aria-controls='navbarNav'
          aria-expanded='false'
          aria-label='Toggle navigation'
          onClick={handleToggle}
        >
          {toggleicon && (
            <img
              src='/images/toggle_icon_sidebar.png'
              className='toggle_icon2'
              width='250'
              alt='toggle_icon'
              onClick={() => {
                setCrossicon(true);
                setToggleicon(false);
              }}
            />
          )}
          {crossicon && (
            <img
              src='/images/Close_icon.png'
              className='toggle_icon3'
              width='250'
              alt='toggle_icon'
              onClick={() => {
                setToggleicon(true);
                setCrossicon(false);
              }}
            />
          )}
        </button>
        <div class={`collapse navbar-collapse ${isNavbarOpen ? 'show' : ''}`} id='navbarNav'>
          <ul class='navbar-nav'>
            <li class='nav-item active'>
              <Link class='nav-link' to={'/'} onClick={closeMenu}>
                Home
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to={'/C'} onClick={closeMenu}>
                C
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to='' onClick={closeMenu}>
                C++
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to='' onClick={closeMenu}>
                JAVA
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to='' onClick={closeMenu}>
                COMPUTER
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to='' onClick={closeMenu}>
                JAVASCRIPT
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to='' onClick={closeMenu}>
                HTML
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to='' onClick={closeMenu}>
                CSS
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to='' onClick={closeMenu}>
                PHP
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to='' onClick={closeMenu}>
                REACT
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to='' onClick={closeMenu}>
                HOWTO
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to='' onClick={closeMenu}>
                TUTORIALS
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to='' onClick={closeMenu}>
                EXERCISE TEST
              </Link>
            </li>
            <li class='nav-item'>
              <Link class='nav-link' to='' onClick={closeMenu}>
                TRY EDITOR
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Header;
